var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ml-1" }, [
    _c(
      "button",
      {
        staticClass: "product-filter",
        class: { active: _vm.isActive },
        attrs: { id: "term--" + _vm.value },
        on: { click: _vm.toggleFilter },
      },
      [_c("span", [_vm._v(_vm._s(_vm.name))])]
    ),
    _vm._v(" "),
    _vm.isActive && _vm.subs.length > 0
      ? _c(
          "ul",
          { staticClass: "nav flex-column ml-1 mb-1" },
          _vm._l(_vm.subs, function (filter, index) {
            return _c(
              "li",
              { key: index },
              [
                _c(
                  "ProductParentFilter",
                  _vm._b({}, "ProductParentFilter", filter, false)
                ),
              ],
              1
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }